var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.996 41.371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n.aa{fill:#fff;}\r\n.cross{fill:#23d8f8;}\r\n"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-687.094 -675.688)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M711.688,700.726a6.672,6.672,0,0,1-6.653,6.653h0a6.788,6.788,0,0,1-6.768-6.768h0a6.672,6.672,0,0,1,6.653-6.653h2.974a.449.449,0,0,0,.45-.449v-10.3a.448.448,0,0,0-.448-.448h-3.061a17.792,17.792,0,0,0-17.741,17.74h0a18.1,18.1,0,0,0,18.047,18.048h0a17.793,17.793,0,0,0,17.74-17.741v-3.06a.448.448,0,0,0-.448-.448h-10.3a.446.446,0,0,0-.447.447Z",
    transform: "translate(0 -1.492)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(711.688 675.688)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cross",
    width: 16.776,
    height: 5.592,
    rx: 1,
    transform: "translate(0 5.592)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cross",
    width: 16.776,
    height: 5.592,
    rx: 1,
    transform: "translate(5.592 16.776) rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728.463 695.819)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M747.622,708.473a3.618,3.618,0,0,1-3.886,2.964c-2.865,0-4.214-2.061-4.214-4.667,0-2.512,1.4-4.76,4.305-4.76a3.467,3.467,0,0,1,3.795,2.965h-1.95a1.789,1.789,0,0,0-1.91-1.423c-1.609,0-2.224,1.476-2.224,3.151,0,1.542.537,3.178,2.277,3.178a1.79,1.79,0,0,0,1.845-1.409Z",
    transform: "translate(-739.522 -701.372)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M750.98,711.266V701.2h1.883v10.065Z",
    transform: "translate(-741.939 -701.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M755.489,702.965V701.2h1.884v1.764Zm0,1.158h1.884v7.143h-1.884Z",
    transform: "translate(-742.89 -701.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M759.367,706.928c0-.585,0-1.223-.013-1.741h1.9c.039.186-.013.665,0,.877a2.055,2.055,0,0,1,1.962-1.037c1.361,0,2.238.944,2.238,2.673v4.374H763.58v-4.161c0-.784-.249-1.342-1.087-1.342-.8,0-1.243.451-1.243,1.674v3.829h-1.884Z",
    transform: "translate(-743.705 -702.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M768.863,702.965V701.2h1.884v1.764Zm0,1.158h1.884v7.143h-1.884Z",
    transform: "translate(-745.711 -701.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M740.819,716.51h3.729c1.924,0,3.219,1.091,3.219,2.832,0,1.994-1.479,2.912-3.258,2.912h-1.74v3.417h-1.95Zm1.95,4.161h1.491c.9,0,1.544-.359,1.544-1.29s-.68-1.3-1.5-1.3h-1.531Z",
    transform: "translate(-739.796 -704.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M750.98,725.428V715.362h1.883v10.066Z",
    transform: "translate(-741.939 -704.188)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M761.482,724.081c0,.652,0,1.542.013,2.154h-1.884c-.026-.186.013-.718,0-.957a1.928,1.928,0,0,1-1.871.957c-1.375,0-2.251-.851-2.251-2.553v-4.494h1.872V723.3c0,.757.235,1.382,1.046,1.382.851,0,1.2-.465,1.2-1.821v-3.669h1.871Z",
    transform: "translate(-742.89 -704.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M766.267,723.959a1.175,1.175,0,0,0,1.282.864c.694,0,.942-.253.942-.678s-.288-.612-1.256-.851c-2.211-.559-2.564-1.25-2.564-2.22,0-1.011.694-2.087,2.735-2.087s2.761,1.143,2.813,2.074h-1.779c-.066-.253-.236-.732-1.113-.732-.615,0-.825.279-.825.586,0,.346.21.505,1.309.771,2.264.532,2.59,1.316,2.59,2.326,0,1.143-.863,2.181-2.918,2.181s-2.9-1.011-3.062-2.234Z",
    transform: "translate(-744.774 -704.953)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5df234f9.svg";
export { ForwardRef as ReactComponent };